import React from 'react';
import {withMeta, withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName} from '@packages/systems/wfdl-Qualified';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {TList, TElement} from '@packages/systems/wfdl-ast';
import {defaultBlockquoteChildrenNodePojo} from '@packages/systems/core/constants/DomNodeDefaults';
import {getChildren} from '@packages/utilities/data-utils';

const basicPlugin = Plugins.name('Basic');

const Blockquote = Atom.createRender(
  ({attributes, classes, generateAttributes, data, innerHTML, renderChild}) => {
    return (
      <blockquote {...generateAttributes(attributes, classes)}>
        {/* @ts-expect-error - TS2322 - innerHTML union includes non-ReactNode array types (TODO platform: fix innerHTML type issues) */}
        {innerHTML || getChildren(data).map((child) => renderChild(child))}
      </blockquote>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Block Quote',
  icon: {type: 'Component', value: [basicPlugin, iconName('Blockquote')]},
  showEmpty: false,
  render: Blockquote,
  fields: {
    children: withSystem(
      {
        isBindable: true,
        label: 'Text',
        defaultValue: defaultBlockquoteChildrenNodePojo,
      },
      TList(withMeta({multiLine: true}, TElement))
    ),
  },
});

export default config;
